import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ENDPOINT } from 'services/configs/endpoint.constant';
import { DocumentService } from 'services/document/document.service';

interface UseTermsProps {
  tokenAvailable: boolean;
}

const useTerms = ({ tokenAvailable }: UseTermsProps) => {
  const [termsUrl, setTermsUrl] = useState('');
  const [isLoading, setIsLoading] = useState(true);
  const [isOpenTermsModal, setIsOpenTermsModal] = useState(false);

  const { i18n } = useTranslation();

  const onClose = () => {
    setIsOpenTermsModal(false);
  };

  useEffect(() => {
    if (tokenAvailable) {
      (async () => {
        const res = await DocumentService.getTermsOfServiceStatus();
        if (!res.user_accepted) {
          if (i18n.language === 'ja') {
            setTermsUrl(ENDPOINT.TERM_OF_SERVICE_JA_LANGUAGE);
          } else {
            setTermsUrl(res.term_and_condition_url);
          }
          setIsOpenTermsModal(true);
        }
        setIsLoading(false);
      })();
    }
  }, [tokenAvailable, i18n.language]);

  return { isLoading, isOpenTermsModal, termsUrl, onClose };
};

export default useTerms;
